import {
  GET_USERS_LIST,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  GET_SINGLE_USER,
  GET_SINGLE_USER_SUCCESS,
  GET_SINGLE_USER_FAIL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  GET_USER_DETAILS_REQUEST,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  APPROVE_USER_REQUEST,
  APPROVE_USER_SUCCESS,
  APPROVE_USER_FAIL,
  RESEND_APPROVE_MAIL_REQUEST,
  RESEND_APPROVE_MAIL_SUCCESS,
  RESEND_APPROVE_MAIL_FAIL,
  APPROVE_USER_BY_SUPER_ADMIN_REQUEST,
  APPROVE_USER_BY_SUPER_ADMIN_SUCCESS,
  APPROVE_USER_BY_SUPER_ADMIN_FAIL,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAIL,
  GET_USER_INVITE_SUCCESS,
  GET_USER_INVITE_FAIL,
  GET_USER_INVITE_REQUEST,
  APPROVE_USER_INVITE_REQUEST,
  APPROVE_USER_INVITE_SUCCESS,
  APPROVE_USER_INVITE_FAIL,
  RESEND_INVITE_MAIL_REQUEST,
  RESEND_INVITE_MAIL_SUCCESS,
  RESEND_INVITE_MAIL_FAIL,
  EDIT_USER_INFO_REQUEST,
  EDIT_USER_INFO_SUCCESS,
  EDIT_USER_INFO_FAIL,
  GET_FILE_REQUEST,
  GET_FILE_SUCCESS,
  GET_FILE_FAIL,
} from "src/constants/types";

export const usersReducer = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_USERS_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: payload,
        error: "",
      };

    case GET_USERS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case DELETE_USER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_USER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_user: payload,
      };
    case GET_SINGLE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CHANGE_PASSWORD:
      return {
        ...state,
        loading: true,
        formError: false,
        change_pass_success: false,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        formError: false,
        change_pass_success: true,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        formError: payload,
        change_pass_success: false,
      };

    case RESET_PASSWORD:
      return {
        ...state,
        loading: true,
        reset_pass_success: false,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        formResetError: false,
        reset_pass_success: true,
      };
    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        formResetError: payload,
        reset_pass_success: false,
      };

    case GET_USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        user_details: payload,
        error: "",
      };
    case GET_USER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case APPROVE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case APPROVE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case APPROVE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case INVITE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case INVITE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case INVITE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_USER_INVITE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_USER_INVITE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case GET_USER_INVITE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case APPROVE_USER_INVITE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case APPROVE_USER_INVITE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case APPROVE_USER_INVITE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESEND_APPROVE_MAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case RESEND_APPROVE_MAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case RESEND_APPROVE_MAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESEND_INVITE_MAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case RESEND_INVITE_MAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case RESEND_INVITE_MAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case APPROVE_USER_BY_SUPER_ADMIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case APPROVE_USER_BY_SUPER_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case APPROVE_USER_BY_SUPER_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case EDIT_USER_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_USER_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case EDIT_USER_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        imageUrl: payload,
        error: "",
      };
    case GET_FILE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
